
export const convertIntoLakh = (amount) => {
    if (amount !== "" && amount !== undefined) {
        if (amount >= 100000 && amount < 10000000) {
            const lakhAmount = amount / 100000;
            return `${Number.isInteger(lakhAmount) ? lakhAmount.toFixed(0) : lakhAmount.toFixed(1)} Lakh`;
        } else if (amount >= 10000000) {
            const croreAmount = amount / 10000000;
            return `${Number.isInteger(croreAmount) ? croreAmount.toFixed(0) : croreAmount.toFixed(1)} Cr`;
        } else if (amount >= 1000) {
            const thousandAmount = amount / 1000;
            return `${Number.isInteger(thousandAmount) ? thousandAmount.toFixed(0) : thousandAmount.toFixed(2)} Thousand`;
        }
        return amount;
    }
};

export const CommaSeprator = (input) => {
    if (input !== null && input !== undefined) {
        let value = input;
        let rupee = value.toString();
        let newRupee = rupee.substring(rupee.length - 3);
        let other = rupee.substring(0, rupee.length - 3);
        if (other !== '')
            newRupee = ',' + newRupee;
        let formattedValue = other.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + newRupee;
        return formattedValue;
    }
};

export const isObjEmpty = (obj) => {
    if (Object.keys(obj)?.length === 0) {
        return true
    } else return false;

}


export const getKYCModel = (params) => {

    const { KYCDetails, AddressDetails, DocType, DocID, IsFileUploaded, IsRedirectUrl } = params;
    const KycComponentDetails = !params.KycComponentDetails ? {} : params.KycComponentDetails;
  
    let NomineeDetails = KYCDetails.nomineeDetails;
/*    if (props.CompanyID === 118) {
        const rel = KycDetails?.Relation?.split("~");
        NomineeDetails.RelationShip = rel?.length > 0 ? rel[1] : "";
        NomineeDetails.Name = rel?.length > 0 ? rel[0] : "";;
    }*/

    const ckycmodel = {
        EnquiryNo: KYCDetails.EnquiryNo,
        InsurerID: KYCDetails.CompanyID,
        DocType: DocType,
        DocNumber: DocID,
        UniqueID: KYCDetails.TransectionID,
        DOB: KYCDetails.DOB,
        Name: KYCDetails.Name,
        Gender: KYCDetails.Gender?.toLowerCase() == 'male' ? 'M' : 'F',
        MobileNo: KYCDetails.Mobile,
        EmailID: KYCDetails.Email,
        PinCode: KYCDetails.PinCode,
        TypeOfMotor: parseInt(KYCDetails.Type),
        TypeOfPolicy: parseInt(KYCDetails.TypeOfPolicy),
        IsCorporate: KYCDetails.IsCorporate,
        OdOnly: KYCDetails.PolicyType === "2",
        ThirdPartyCover: KYCDetails.PolicyType === "1",
        ProductType: KYCDetails.ProductType,
        IsFileUploaded,
        IsRedirectUrl,
        FromHealth: KYCDetails.FromHealth == true,
        SelectedPOA: IsFileUploaded ? KycComponentDetails.SelectedPOA : "",
        SelectedPOI: IsFileUploaded ? KycComponentDetails.SelectedPOI : "",
        SelectedPOAValue: IsFileUploaded ? KycComponentDetails.selectedPOAValue : "",
        SelectedPOIValue: IsFileUploaded ? KycComponentDetails.SelectedPOIValue : "",
        nomineeDetails: NomineeDetails,
        AddressDetails: {
            CPinCode: AddressDetails.PinCode,
            CState: AddressDetails.StateName,
            CCity: AddressDetails.CityName,
            CDistrict: AddressDetails.CityName,
            CAddressLine1: AddressDetails.AddressLine1,
            CAddressLine2: AddressDetails.AddressLine2,
            CAddressLine3: AddressDetails.AddressLine3,
            PAddressLine1: AddressDetails.IsChangeAddress ? AddressDetails.PerAddressLine1 : AddressDetails.AddressLine1,
            PAddressLine2: AddressDetails.IsChangeAddress ? AddressDetails.PerAddressLine2 : AddressDetails.AddressLine2,
            PAddressLine3: AddressDetails.IsChangeAddress ? AddressDetails.PerAddressLine3 : AddressDetails.AddressLine3,
            PCity: AddressDetails.IsChangeAddress ? AddressDetails.PerCityName : AddressDetails.CityName,
            PPinCode: AddressDetails.IsChangeAddress ? AddressDetails.PerPinCode : AddressDetails.PinCode,
            PState: AddressDetails.IsChangeAddress ? AddressDetails.PerStateName : AddressDetails.StateName,
            PDistrict: AddressDetails.IsChangeAddress ? AddressDetails.PerCityName : AddressDetails.CityName
        }
    }


    return ckycmodel;
}